"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Collapsible = function Collapsible(props) {
  var isCollapsed = props.isCollapsed,
      className = props.className,
      children = props.children;
  return /*#__PURE__*/_react["default"].createElement(StyledCollapsible, {
    className: className,
    isCollapsed: isCollapsed
  }, children);
};

var StyledCollapsible = _styledComponents["default"].div.withConfig({
  displayName: "Collapsible__StyledCollapsible",
  componentId: "sc-ti2qut-0"
})(["transition:height 0.2s ease-in-out;", ""], function (_ref) {
  var isCollapsed = _ref.isCollapsed;
  return isCollapsed && "\n    height: 0;\n    overflow: hidden;\n  ";
});

var _default = Collapsible;
exports["default"] = _default;